var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { get } from "lodash";
import qs from "qs";
import styled from "styled-components";
import GetCommentAnonChat from "@irati/insights/apollo/query/Chatroom/Comment";
import GetRoomAnonChat from "@irati/insights/apollo/query/Chatroom/Room";
import { Hr } from "@irati/ui/src/Layout";
import History from "@irati/utils/history";
import authentication from "@irati/auth";
import { H5, H3 } from "@irati/ui/src/Headings";
import { FormattedMessage } from "@irati/utils/lang";
import padding from "@irati/ui/src/global/padding";
import { Page } from "../../components/Layout";
import { Comment, Messages, NewMessage } from "../../components/Chatroom";
import { Breadcrumbs } from "../../components/Navigation";
import sitemap from "../sitemap";
var StyledPage = styled(Page)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column-reverse;\n"], ["\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var OverflowAnchor = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-anchor: auto;\n"], ["\n  overflow-anchor: auto;\n"])));
var SpacedH3 = styled(H3)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-top: ", ";\n"], ["\n  padding-top: ", ";\n"])), padding.base);
var SpacedH5 = styled(H5)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", " 0;\n"], ["\n  padding: ", " 0;\n"])), padding.base);
var Chatroom = /** @class */ (function (_super) {
    __extends(Chatroom, _super);
    function Chatroom() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Chatroom.prototype.render = function () {
        var _a = this.props, match = _a.match, location = _a.location;
        var roomId = match.params.roomId;
        var commentId = qs.parse(location.search.replace("?", "")).commentId;
        return (React.createElement(StyledPage, null,
            React.createElement(GetRoomAnonChat, { uuid: roomId }, function (_a) {
                var roomData = _a.data;
                var subjectResourceUuid = get(roomData, "insRoom.subjectResourceUuid");
                var isUserAnonymous = get(roomData, "insRoom.isUserAnonymous");
                return (React.createElement(React.Fragment, null,
                    React.createElement(OverflowAnchor, null,
                        React.createElement(NewMessage, { isUserAnonymous: isUserAnonymous, commentId: commentId, roomUuid: roomId })),
                    React.createElement(OverflowAnchor, null,
                        React.createElement(Messages, { roomUuid: roomId })),
                    React.createElement(Hr, { solid: true }),
                    React.createElement(GetCommentAnonChat, { id: subjectResourceUuid || commentId }, function (_a) {
                        var data = _a.data;
                        var comment = get(data, "insightsComment");
                        var reference = get(data, "insightsComment.cycle.reference");
                        var crumbs = [sitemap.homepage, { onClick: History.goBack, title: reference }, sitemap.chatroom];
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Comment, { comment: comment }),
                            authentication.isGlobalAdmin()
                                ? React.createElement(Breadcrumbs, { crumbs: crumbs })
                                : (React.createElement("div", null,
                                    React.createElement(SpacedH3, null,
                                        React.createElement(FormattedMessage, { id: "insights.chatroom.anonymous.primaryHeading", values: { reference: reference } })),
                                    React.createElement(SpacedH5, null,
                                        React.createElement(FormattedMessage, { id: "insights.chatroom.anonymous.secondaryHeading" }))))));
                    })));
            })));
    };
    return Chatroom;
}(Component));
export default Chatroom;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
